import produce from 'immer';

import {
  FETCH_PAYMENT_COLLECTIONS_PREFERENCES_FAILURE,
  FETCH_PAYMENT_COLLECTIONS_PREFERENCES_SUCCESS,
  UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_FAILURE,
  UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_SUCCESS,
} from '@actions/paymentCollections';

const initialState: IPaymentCollectionsStore = {
  paymentCollectionsPrefrences: null,
  error: null,
};

export default (state: IPaymentCollectionsStore = initialState, action: any) =>
  produce(state, (draftState: IPaymentCollectionsStore) => {
    switch (action.type) {
      case FETCH_PAYMENT_COLLECTIONS_PREFERENCES_SUCCESS:
      case UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_SUCCESS:
        draftState.paymentCollectionsPrefrences = action.response;
        draftState.error = null;

        return;
      case FETCH_PAYMENT_COLLECTIONS_PREFERENCES_FAILURE:
      case UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_FAILURE:
        draftState.error = action.error;

        return;

      default:
        return;
    }
  });
